
import axios from "axios";
const BaseURL = process.env.REACT_APP_BASE_URL

const studentServices = {

    getSchoolList(qurey) {
        return new Promise(async (resolve, reject) => {

            try {
                const resp = await axios.get(`${BaseURL}student/universities`);    //Common For All School List
                resolve(resp.data)
            } catch (err) {
                reject(err)
            }

        })
    },

    uploadStudentDoc(docFile) {
        return new Promise(async (resolve, reject) => {

            try {
                const resp = await axios.post(`${BaseURL}student/upload/document`, docFile);    //Common For All School List
                resolve(resp.data)
            } catch (err) {
                reject(err)
            }

        })
    },

    UpdateStudentData(bio) {
        return new Promise(async (resolve, reject) => {

            try {
                const resp = await axios.patch(`${BaseURL}student/info`, bio);    //Common For All School List
                resolve(resp.data)
            } catch (err) {
                reject(err)
            }

        })
    },

    getStudentProfile(userid) {
        return new Promise(async (resolve, reject) => {

            try {
                let resp
                if(userid){
                    resp   = await axios.get(`${BaseURL}student/profile?user_id=${userid.user_id}`);
                }
                else{
                     resp = await axios.get(`${BaseURL}student/profile`);
                }
                
                resolve(resp)
            } catch (err) {
                reject(err)
            }

        })
    },
    
    getStudentDoc(Docdetails) {
        return new Promise(async (resolve, reject) => {

            try {
                const resp = await axios.post(`${BaseURL}student/get/document`,Docdetails);
                resolve(resp)
            } catch (err) {
                reject(err)
            }

        })
    },
      getStudentRotation(reqData) {
        return new Promise(async (resolve, reject) => {
            try {
                const resp = await axios.get(`${BaseURL}student/getRotationRequests?school_id=${reqData.school_id}&date=${reqData.date}`);
                resolve(resp)
            } catch (err) {
                reject(err)
            }

        })
    }
}

export default studentServices